import React from 'react';
import { Box, TextButton } from '@freenow/wave';
import { DropdownChevronIcon } from './DropdownChevronIcon';
export const ClickableHeaderContent = ({ isOpen, detailsTitle, onClick }) => (React.createElement(Box, { display: "flex", alignItems: "center", mb: 2, stlye: { cursor: 'pointer' }, onClick: onClick },
    React.createElement(TextButton, { size: "small" }, detailsTitle),
    React.createElement(DropdownChevronIcon, { isOpen: isOpen })));
